import Blog from "."; 

export const blogsRoutes = () => [
  {
    path: "/blogs",
    component: Blog,
    layout: "front",
    title: "page",
  },
];